import Rest from '@/services/Rest'

export default class CodingSchemaService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/documentTypeCodingSchemas'

}
